<template>
  <div class="bg-surface-bg-accent size-full flex align-center">
    <v-container class="py-0 flex align-center justify-space-between">
      <u-text
        color="#fff"
        class="text-body-xs flex align-center"
      >
        {{ props.text }}
        <u-link
          v-bind="props.link"
          color="link-invert"
          class="text-body-xs font-bold ms-1"
          @click="trackEvent({ event: 'gaEvent', eventCategory: 'Navigation', eventLabel: 'Advisor' })"
        />
      </u-text>
      <u-link
        v-bind="props.login"
        color="link-invert"
        class="text-body-xs font-bold"
        text="Login"
      />
    </v-container>
  </div>
</template>

<script setup lang="ts">
const definedProps = defineProps<{
  text?: string
  link?: Partial<{
    href: string
    to: string
    text: string
  }>
  login?: Partial<{
    href: string
    to: string
  }>
}>()

const props = useDefaults(definedProps, 'HeaderExtension')

const { trackEvent } = useGtm()
</script>
